import { FooterSchema } from './Footer.styles';

export const footerStyles: FooterSchema = {
  footer: {
    pt: '0',
    bg: 'transparent',
    bgSize: 'cover',
    bgPos: 'bottom',
    color: 'white',
  },
  stackGap: '0',
  footerBar: {
    display: 'flex',
    flexDir: ['column', null, 'row'],
    pr: '0',
    mb: ['4', '8'],
    borderRadius: 'md',
    alignItems: 'center',
    justifyContent: ['center', null, 'unset'],
    sx: {
      '& > img': {
        maxW: '250px',
        h: '55px',
        ml: '0',
      },
    },
  },
  footerMobile: {
    border: '2px',
    borderColor: 'white',
    borderRadius: 'lg',
    w: '130px',
    cursor: 'pointer',
    boxShadow: '0px 2px 7px rgba(0, 0, 0, 0.3)',
  },
  footerText: {
    fontSize: 'sm',
  },
  footerLinkService: {
    color: 'delta.500',
    fontSize: 'md',
  },
  footerLink: {
    color: 'delta.500',
    textTransform: 'lowercase',
    cursor: 'pointer',
    display: 'inline-block',
    mt: '0',
    whiteSpace: 'nowrap',
    fontWeight: 'bold',
    fontSize: 'sm',
  },
  footerLinkTel: {
    color: 'delta.500',
    textTransform: 'lowercase',
    cursor: 'pointer',
    display: 'inline-block',
    mt: '0',
    whiteSpace: 'nowrap',
    fontWeight: 'bold',
    fontSize: 'sm',
  },
  customFooterLink: {
    color: 'delta.500',
    textTransform: 'capitalize',
    cursor: 'pointer',
    display: 'inline-block',
    mt: '0',
    whiteSpace: 'nowrap',
    fontWeight: 'bold',
    fontSize: 'sm',
  },
  footerLinks: {
    ml: ['unset', null, 'auto'],
    pb: ['4', null, '0'],
    alignItems: 'center',
    justifyContent: ['space-around', null, 'unset'],
    color: 'white',
    fontWeight: 'medium',
    flexDir: ['row', null, 'unset'],
    display: 'inline-flex',
    mt: ['3', null],
    gap: '2',
  },
  footerContentContainer: {
    px: ['2.5', 'unset'],
    gap: ['2', '6'],
    bg: [null, null, 'transparent'],
    justifyContent: 'space-between',
    sx: {
      '&': {
        flexDirection: 'column',
      },
    },
  },
  nav: {
    fontSize: 'sm',
    fontWeight: 'medium',
    minW: [null, null, '370px'],
    mt: ['0', 'unset'],
    display: ['flex', 'grid'],
    gridTemplateColumns: '1fr 1fr 1fr',
    gridTemplateRows: 'auto',
    columnGap: '28',
    rowGap: ['0', '2'],
    alignItems: ['center', 'end'],
    gridTemplateAreas: `
      ". ."
    `,
    sx: {
      '> a': {
        color: 'white',
      },
    },
  },
  blurb: {
    flex: 'unset',
    textAlign: ['center', 'left'],
    color: 'white',
    width: 'unset',
    mb: '0',
    ml: [null, '0'],
    mr: [null, null, '4'],
  },
  blurbHeading: {
    ml: 'unset',
    mt: 'unset',
    color: 'white',
  },
  blurbHeadingAge: {
    borderColor: 'blackAlpha.50',
    border: '4px',
    mb: '2',
    boxSize: '8',
    fontSize: 'xs',
  },
  blurbHeadingThink: {
    fontSize: 'xs',
    fontWeight: 'bold',
    mb: '3',
  },
  blurbContent: {
    ml: 'unset',
    mr: [null, null, 'auto'],
  },
  copyright: {
    color: 'white',
    textAlign: ['center', 'left'],
    mt: ['7'],
    px: ['8', 'unset'],
    py: '0',
    fontWeight: ['semibold', 'medium'],
  },
  container: {
    bg: 'transparent',
    borderRadius: ['0', '0', '8'],
    p: '0',
    sx: {
      '&&': {
        px: '0',
      },
    },
    mt: '3',
  },
  emailUs: {
    fontSize: 'md',
    fontWeight: 'bold',
  },
  quickLinks: {
    color: 'white',
    fontSize: 'md',
    textAlign: ['center', 'left'],
  },
  ourPartners: {
    fontSize: 'md',
  },
  weAccept: {
    fontSize: 'md',
  },
  footerDownloadImage: {
    borderRadius: 'md',
    border: 'none',
  },
  weAcceptBox: {
    mb: '2',
  },
};
